import { axiosClient } from '../axiosClient';
import type { FinanceData, FinancePeriod } from '@/types/finance.types';

export const getFinance = async (period: FinancePeriod = 'mes'): Promise<FinanceData> => {
  try {
    const response = await axiosClient.get('/admin/finance', { params: { period } });
    return response.data;
  } catch (error) {
    console.error('Failed to fetch finance:', error);
    throw error;
  }
};
